import React from 'react';
import { BodyCell, HeadCell, SizeGuideTable } from './SizeGuide.css';

const renderRow = (data, index, headerRow = false, columnHeadersCount = 0) => {
  const leftAlignFirstColumn = columnHeadersCount === 0;
  return (
    <tr key={`size_guide_row_${index}`}>
      {data.map((el, idx) =>
        headerRow || idx < columnHeadersCount ? (
          <HeadCell leftAligned={leftAlignFirstColumn && idx === 0} key={`size_guide_row_header_${index}-${el}`}>
            {el}
          </HeadCell>
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <BodyCell leftAligned={leftAlignFirstColumn && idx === 0} key={`size_guide_row_td_${index}_${idx}-${el}`}>
            {el}
          </BodyCell>
        ),
      )}
    </tr>
  );
};

const dataAsHeader = (data, columnHeadersCount) => (
  <thead>{renderRow(data, `${data}_head_index`, true, columnHeadersCount)}</thead>
);

const dataAsBody = (data, idx, columnHeadersCount) => renderRow(data, idx, false, columnHeadersCount);

const renderTable = (data, columnHeadersCount = 0, hasRowHeader = true) => {
  const body = hasRowHeader ? data.slice(1, data.length) : data;

  return (
    <SizeGuideTable className="table">
      {hasRowHeader && dataAsHeader(data[0], columnHeadersCount)}
      <tbody>{body.map((el, idx) => dataAsBody(el, idx, columnHeadersCount))}</tbody>
    </SizeGuideTable>
  );
};

const renderTableByColumns = (data, headerFirstColumnsCount = 0) => {
  // transpose the data matrix
  const transposedData = data[0].map((col, i) => data.map(row => row[i]));
  return renderTable(transposedData, headerFirstColumnsCount);
};

export { renderRow, renderTable, renderTableByColumns };
